var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-entity__status c-entity__status-tracked flex-container flex-justify-space-between"},[_vm._m(0),_c('span',[_c('a',{on:{"click":function($event){$event.preventDefault();return _vm.toggle.apply(null, arguments)}}},[_vm._v("Turn off tracking for this Account")])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._v("This account "),_c('strong',[_vm._v("IS")]),_vm._v(" tracked.")])
}]

export { render, staticRenderFns }